import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE } from "./vehicle-valuation-price-adjustment.types";

export function useVehicleValuationPriceAdjustmentDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete<void>(`/v1/${VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE],
      });
    },
  });
}
